import React from 'react';
import Signup from '../components/Signup/Signup';
import SignupFooter from '../components/SignupFooter/SignupFooter'; // 1. Import the NEW footer

const SignupPage = () => {
  return (
    <>
      <Signup />
      <SignupFooter /> {/* 2. Use the NEW footer here */}
    </>
  );
};

export default SignupPage;